import React from 'react';
import isNil from 'lodash/isNil';
import {
  EligibilityOverviewPayer,
} from 'dtos/eligibilityOverviewPayer';
import Section from 'views/EMR/components/Eligibility/Overview/Section';
import Field from 'views/EMR/components/Eligibility/Overview/Field';
import InsuranceIcon from 'core/icons/insurance';

type Props = {
  payer: EligibilityOverviewPayer;
};

export default function Payer({ payer }: Props) {
  const { name, payerId } = payer;

  return (
    <Section title="Payer">
      <div className="flex flex-wrap gap-x-6 gap-y-3">
        <div className="flex flex-col gap-0.5 min-w-[220px]">
          <span className="text-xs text-gray-500">Organization name</span>
          {!isNil(name) && (
            <div className="flex items-center gap-1.5">
              <InsuranceIcon className="text-gray-400 !w-4 !h-4" />
              <span className="text-xs font-semibold text-gray-700 whitespace-nowrap">{name}</span>
            </div>
          )}
        </div>
        <Field label="ID" value={payerId} />
      </div>
    </Section>
  );
}
